import React from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

import classes from "./RootLayout.module.sass";
import { Footer } from "../common/components/footer/Footer";
import { Bar } from "../common/components/bar/Bar";
import { CityModal } from "../common/components/cityModal/CityModal";
import { FloatingCarts } from "../common/components/floatingCarts/FloatingCarts";
import { ScrollTopButton } from "../common/components/scrollTopButton/ScrollTopButton";
import { useRootLayout } from "./useRootLayout";
import { useScrollToTop } from "../common/hooks/useScrollToTop";
import { selectModalState } from "../store/slices/commonModalSlice";
import { CommonModals } from "../common/types/enums";
import { RootState } from "../store/store";

export const RootLayout: React.FC = () => {
  useRootLayout();
  useScrollToTop();

  const isCityModalOpen = useSelector((state: RootState) =>
    selectModalState(state, CommonModals.CITY_SELECT),
  );

  return (
    <div className={classes.Container}>
      <Bar />
      <main className={classes.Content}>
        <Outlet />
      </main>
      <Footer />
      <CityModal isVisible={isCityModalOpen} />
      <FloatingCarts />
      <ScrollTopButton />
    </div>
  );
};
